import heic2any from 'heic2any';
import { appConfig } from './generated/appConfig';

function isHeic(file: File): boolean {
  return /heic|heif/i.test(file.type) || /\.(heic|heif)$/i.test(file.name);
}

async function decodeSource(file: File): Promise<Blob> {
  if (!isHeic(file)) return file;
  const result = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.92 });
  return Array.isArray(result) ? result[0] : result;
}

export async function normalizePhoto(file: File): Promise<Blob> {
  const source = await decodeSource(file);
  const bitmap = await createImageBitmap(source);
  const scale = Math.min(1, appConfig.photo.maxEdgePx / Math.max(bitmap.width, bitmap.height));
  const width = Math.max(1, Math.round(bitmap.width * scale));
  const height = Math.max(1, Math.round(bitmap.height * scale));
  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Bildverarbeitung wird vom Browser nicht unterstützt.');
  context.drawImage(bitmap, 0, 0, width, height);
  bitmap.close();
  const blob = await new Promise<Blob>((resolve, reject) =>
    canvas.toBlob(value => value ? resolve(value) : reject(new Error('JPG-Konvertierung fehlgeschlagen.')), 'image/jpeg', appConfig.photo.jpegQuality)
  );
  if (blob.size > appConfig.photo.maxUploadBytes) throw new Error('Das verkleinerte Foto ist weiterhin zu groß.');
  return blob;
}
